import type { VolumeMountItem } from '../volumeTypes';

/** 编辑回填：优先按 containerName 匹配，单容器场景回退首条挂载，避免因名称未对齐丢 mountPath */
export function resolveVolumeMountForEdit(
  volumeMounts: VolumeMountItem[] | undefined,
  containerName?: string,
): VolumeMountItem | undefined {
  if (!volumeMounts?.length) return undefined;
  const trimmed = containerName?.trim();
  if (trimmed) {
    const matched = volumeMounts.find((item) => item.containerName === trimmed);
    if (matched) return matched;
  }
  return volumeMounts[0];
}
